<mg-configurator-content *ngIf="deal$ | async as deal">
    <mg-checkout-options-layout
        [deal$]="deal$"
        [layoutTrigger$]="layoutTrigger$"
        [modelName]="deal.modelName"
        [routeIndex]="3"
        [withCarPreview]="false"
    >
        <ng-container mg-remaining-fields>
            <mg-configuration-factory-tabs class="above-content" position="top"></mg-configuration-factory-tabs>

            <mg-ui-card
                *ngIf="!deal.requirements.isCompanyRequired"
                title="Your details"
                i18n-title="@@configurator.final-step.personal-details-title"
            >
                <mg-deal-user-profile
                    [displayAddress]="hasCheckout"
                    [displayPhonenumber]="true"
                    (changeHasFullAddress)="onUserProfileChange($event)"
                    #userProfile
                ></mg-deal-user-profile>
            </mg-ui-card>

            <mg-ui-card
                *ngIf="deal.requirements.isCompanyRequired"
                title="Company details"
                i18n-title="@@configurator.final-step.company-details-title"
            >
                <mg-configuration-option-company-form
                    [initialLessee]="deal.lessee"
                ></mg-configuration-option-company-form>
            </mg-ui-card>

            <mg-ui-card
                *ngIf="deal.requirements.isDriverRequired"
                title="Driver details"
                i18n-title="@@configurator.final-step.driver-details-title"
            >
                <mg-configuration-option-text-driver></mg-configuration-option-text-driver>
            </mg-ui-card>

            <mg-ui-card class="config-save">
                <mg-ui-button
                    id="button-send-title"
                    [disabled]="!canSubmit"
                    [isLoading]="isSubmitting"
                    [isGhost]="true"
                    [scrollToInvalid]="true"
                    type="submit"
                    errorMessage="Not all mandatory fields have been filled in"
                    i18n-errorMessage="@@configurator.general.next-step-button.error-message"
                    (click)="onSubmit()"
                    i18n="@@configurator.general.button-step-four"
                    >View your offer</mg-ui-button
                >
            </mg-ui-card>

            <mg-configuration-factory-tabs position="bottom"></mg-configuration-factory-tabs>
        </ng-container>
    </mg-checkout-options-layout>
</mg-configurator-content>
